import React from 'react';
import { motion } from 'framer-motion';
import { BarChart3, PiggyBank, CreditCard, LineChart, Video, ArrowRight } from 'lucide-react';
import { Button } from './Button';
const cards = [{
  title: 'Presupuesto Mensual',
  description: 'Registrá todos tus ingresos y gastos de forma simple. Vas a ver exactamente en qué se te va el dinero y dónde podés recortar para llegar a fin de mes con más tranquilidad.',
  icon: BarChart3,
  image: 'https://cdn.magicpatterns.com/uploads/frC26ws6ytZbUju9m2NUof/presupuesto_mensual.png',
  delay: 0
}, {
  title: 'Plan de Ahorros',
  description: 'Definí tus objetivos de ahorro, establecé plazos y seguí tu progreso mes a mes. Ideal para ahorrar para viajes, emergencias o metas personales sin perder motivación.',
  icon: PiggyBank,
  image: 'https://cdn.magicpatterns.com/uploads/kFpaeSwzAPsXK7gVg5ASJ5/ahorros.png',
  delay: 0.1
}, {
  title: 'Gestión de Deudas',
  description: 'Registrá todas tus deudas y planificá pagos de forma ordenada. Incluye métodos como Bola de Nieve y Avalancha para salir de deudas más rápido y con menos estrés.',
  icon: CreditCard,
  image: 'https://cdn.magicpatterns.com/uploads/qUAqVBEcFDywYa2VmfcsVt/deudas.png',
  delay: 0.2
}, {
  title: 'Resumen Anual',
  description: 'Obtené una visión clara de todo tu año financiero. Ingresos, gastos, ahorros y balances en un solo lugar para tomar mejores decisiones.',
  icon: LineChart,
  image: 'https://cdn.magicpatterns.com/uploads/bqVA5JpGe1VeATUYHUG8Mi/resumen_anual.png',
  delay: 0.3
}, {
  title: 'Video Tutorial Paso a Paso',
  description: 'Incluye un video explicativo donde te muestro cómo usar cada parte de la plantilla. No necesitás saber de Excel ni de finanzas: lo configurás en minutos.',
  icon: Video,
  image: 'https://cdn.magicpatterns.com/uploads/h8YKVztxDQvFmF99aMJaNm/Instrucciones.png',
  delay: 0.4
}];
export function WhatIncludes() {
  return <section className="py-20 bg-white" data-id="element-191">
      <div className="container mx-auto px-4 md:px-6" data-id="element-192">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-193">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-194">
            ¿Qué incluye la Plantilla de Finanzas Personales?
          </h2>
          <p className="text-xl text-gray-600" data-id="element-195">
            Un sistema simple para ordenar tu dinero, salir de deudas y empezar
            a ahorrar sin complicaciones.
          </p>
        </div>

        {/* Grid Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-196">
          {/* First 3 cards */}
          {cards.slice(0, 3).map((card, index) => <Card key={index} {...card} data-id="element-197" />)}

          {/* Last 2 cards centered in bottom row on desktop */}
          <div className="lg:col-span-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8 lg:w-2/3 lg:mx-auto" data-id="element-198">
            {cards.slice(3, 5).map((card, index) => <Card key={index + 3} {...card} data-id="element-199" />)}
          </div>
        </div>

        <div className="text-center" data-id="element-200">
          <Button href="#precio" className="px-10 py-4 text-lg group" data-id="element-201">
            Obtener la plantilla ahora
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-202" />
          </Button>
        </div>
      </div>
    </section>;
}
function Card({
  title,
  description,
  icon: Icon,
  image,
  delay
}: any) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay,
    duration: 0.5
  }} className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-100 hover:shadow-xl transition-shadow flex flex-col h-full" data-id="element-203">
      <div className="h-48 overflow-hidden bg-gray-50" data-id="element-204">
        <img src={image} alt={title} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" data-id="element-205" />
      </div>
      <div className="p-6 flex-1 flex flex-col" data-id="element-206">
        <div className="flex items-center gap-3 mb-4" data-id="element-207">
          <div className="p-2 bg-teal-50 rounded-lg text-teal-600" data-id="element-208">
            <Icon className="w-5 h-5" data-id="element-209" />
          </div>
          <h3 className="text-xl font-bold text-gray-900" data-id="element-210">{title}</h3>
        </div>
        <p className="text-gray-600 leading-relaxed text-sm flex-1" data-id="element-211">
          {description}
        </p>
      </div>
    </motion.div>;
}